module.exports = "pegasus_template/assets/square-google.png";